import React, {useState, useEffect} from "react";
import MuiAlert from "@material-ui/lab/Alert";
import {WarningIcon} from "../svgIcons/index";
import {MapStateToProps, connect} from "react-redux";

type Color = 'success' | 'info' | 'warning' | 'error';

interface OwnProps {
    severity: Color,
    text: any
}

interface ConnectStateProps {
    Case?: any,
}

type Props = OwnProps & ConnectStateProps

const NotificationBox = (props: Props) => {
    const [text, setText] = useState(props.text),
        {Case} = props;
    useEffect(() => {
        console.log('text1', props.text)
        if(typeof text === "object") {
            setText(text[Case.payment_type])
        } else {
            setText(props.text)
        }
    }, [props.text]);
    console.log('text', text)
    return (
        <MuiAlert icon={props.severity === "warning"  ? <WarningIcon/> : ''} className="mb-4 py-1" severity={props.severity}>
            <div className="d-flex align-items-center align-content-center">
                <span>
                    {typeof text !== 'object' ? text : null}
                </span>
            </div>
        </MuiAlert>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, Object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Case} = state;
    return {
        Case
    }
};

export default connect(mapStateToProps)(NotificationBox);
